var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.hasFile
    ? _c(
        "div",
        { staticClass: "pdf-field-editor" },
        [
          _c(
            "div",
            { staticClass: "pdf-field-editor__toolbar" },
            [
              _vm.pages && _vm.loaded
                ? _c("PdfViewportTools", {
                    attrs: { pages: _vm.pages },
                    model: {
                      value: _vm.page,
                      callback: function($$v) {
                        _vm.page = $$v
                      },
                      expression: "page"
                    }
                  })
                : _vm._e(),
              _vm.loaded
                ? _c("span", { staticClass: "pdf-field-editor__count" }, [
                    _vm._v(
                      " " +
                        _vm._s(_vm.fieldsOnPage.length) +
                        " en esta página · " +
                        _vm._s(_vm.value.length) +
                        " en total "
                    )
                  ])
                : _vm._e(),
              _vm.loaded
                ? _c(
                    "div",
                    { staticClass: "pdf-field-editor__zoom" },
                    [
                      _c(
                        "b-button",
                        {
                          attrs: { size: "sm", variant: "outline-primary" },
                          on: { click: _vm.zoomOut }
                        },
                        [
                          _c("feather-icon", { attrs: { icon: "ZoomOutIcon" } })
                        ],
                        1
                      ),
                      _c(
                        "span",
                        { staticClass: "pdf-field-editor__zoom-label" },
                        [_vm._v(_vm._s(_vm.zoomPercent) + "%")]
                      ),
                      _c(
                        "b-button",
                        {
                          attrs: { size: "sm", variant: "outline-primary" },
                          on: { click: _vm.zoomIn }
                        },
                        [_c("feather-icon", { attrs: { icon: "ZoomInIcon" } })],
                        1
                      ),
                      _c(
                        "b-button",
                        {
                          attrs: { size: "sm", variant: "outline-secondary" },
                          on: { click: _vm.resetZoom }
                        },
                        [_vm._v(" 100% ")]
                      )
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          ),
          _c(
            "div",
            { ref: "scroll", staticClass: "pdf-field-editor__scroll" },
            [
              _c(
                "div",
                {
                  staticClass: "pdf-field-editor__zoom-frame",
                  style: _vm.zoomFrameStyle
                },
                [
                  _c(
                    "div",
                    {
                      ref: "page",
                      staticClass: "pdf-field-editor__page",
                      style: _vm.pageStyle,
                      on: { click: _vm.onPageClick }
                    },
                    [
                      _c("Pdf", {
                        ref: "pdf",
                        staticClass: "pdf-field-editor__canvas",
                        attrs: { page: _vm.actualPage, src: _vm.file },
                        on: {
                          "page-loaded": _vm.onPageLoaded,
                          "page-size": _vm.onPageSize
                        }
                      }),
                      _c(
                        "div",
                        {
                          ref: "overlay",
                          staticClass: "pdf-field-editor__overlay"
                        },
                        _vm._l(_vm.fieldsOnPage, function(field) {
                          return _c("DraggableField", {
                            key: field.id,
                            ref: "fieldRefs",
                            refInFor: true,
                            attrs: {
                              "data-field-id": field.id,
                              field: field,
                              screen: _vm.screenRectFor(field),
                              bounds: _vm.overlayBounds,
                              container: _vm.overlayEl,
                              zoom: _vm.zoom,
                              "snap-lines-provider": _vm.snapLinesFor,
                              selected: field.id === _vm.selectedId,
                              closable: !_vm.readonly
                            },
                            on: {
                              select: function($event) {
                                return _vm.selectField(field.id)
                              },
                              delete: function($event) {
                                return _vm.removeField(field.id)
                              },
                              "geometry-change": function($event) {
                                return _vm.onGeometryChange(field, $event)
                              }
                            }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  )
                ]
              )
            ]
          ),
          _c("b-overlay", { attrs: { show: !_vm.loaded, "no-wrap": "" } })
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }